export class LicenseStringModel {
  public id: number;
  public content: string;
  public technology: string;

  public constructor() {
    this.id = 0;
    this.content = "";
    this.technology = "";
  }
}
